import { render, staticRenderFns } from "./configuration_index_view.vue?vue&type=template&id=1d0c853e"
import script from "./configuration_index_view.vue?vue&type=script&lang=js"
export * from "./configuration_index_view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports